//Global External Imports
import { useTranslation } from "react-i18next";
import ReactDOM from "react-dom";
import React, { useEffect, useState, Fragment, useRef } from "react";
import {
  Button,
  Grid,
  Card,
  Box,
  OutlinedInput,
  InputLabel,
  MenuItem,
  FormControl,
  Chip,
  Autocomplete,
  TextField,
  Typography,
  Fab,
  Popover,
} from "@mui/material";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { API_BASE_URL } from "../../constants/apiConstants";
import openFile from "../shared/functions/download";
//Global Internal Imports
import apiRequest from "../../functions/api";
import { useMessage } from "../../context/message-context";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import Formular from "../Formular/Formular";
import { FullPageSpinner } from "../lib";
import MessageBox from "../shared/components/MessageBox";
import ResponsiveDialog from "../shared/components/ResponsiveDialog";
//Child Imports
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import CheckIcon from "@mui/icons-material/Check";
import SendIcon from "@mui/icons-material/Send";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddIcon from "@mui/icons-material/Add";
function FormularEingabe(props) {
  const { t } = useTranslation();
  //Standardfelder
  const { client, accessToken, formular, formularkey, workflow, Reload, setFormular, setFormularkey, ankey, ans, edit, noNavigate, bearbeiten } = props;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: 500,
        width: 250,
      },
    },
  };
  const [htmlCode, setHtmlCode] = useState("");
  const { showErrorMessage, showSuccessMessage } = useMessage();
  const navigate = useNavigate();
  const [formularBez, setFormularBez] = useState("");
  const [felder, setFelder] = useState({});
  const [felder2, setFelder2] = useState({});
  const [hper, setHper] = useState({});
  const [stammfelder, setStammfelder] = useState({});
  const [listeFormular, setListeFormular] = useState([]);
  const [status, setStatus] = useState("");
  const [uebergaben, setUebergaben] = useState({});
  const [felderError, setFelderError] = useState([]);
  const [files, setFiles] = useState([]);
  const [buttons, setButtons] = useState("");
  const [loading, setLoading] = useState(false);
  const [bemerkung, setBemerkung] = useState("");
  const [messageBoxOpen, setMessageBoxOpen] = useState(false);
  const [delmsg, setDelmsg] = useState(false);
  const [absendenMSG, setAbsendenMSG] = useState(false);
  const [antragsBezeichnungModal, setAntragsBezeichnungModal] = useState(false);
  const [antragsBezeichnungZwischenSpeichernModal, setAntragsBezeichnungZwischenSpeichernModal] = useState(false);
  const [antragsBezeichnung, setAntragsBezeichnung] = useState("");
  const [keyModus, setKeymodus] = useState(false);
  const [stornomsg, setStornomsg] = useState(false);
  const uploadFormData = useRef(new FormData());
  const [folgeformular, setFolgeformular] = useState("");
  const druck = useRef(0);
  const change = useRef(false);
  const location = useLocation();
  const currpos = useRef(0);
  const loadedankey = useRef("");
  const [openPers, setOpenPers] = useState(false);
  const [hideActionButtons, setHideActionButtons] = useState(true);
  const [personName, setPersonName] = useState([]);
  const [dbliste, setDbliste] = useState([]);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [ankeyRes, setAnKEyRes] = useState();

  //State wird ín Saldenauszahlung.js verwaltet und hat den Sinn das Absenden von Anträgen zu verhindern, wenn in dem LohnZR bereits für das Konto eine Auszahlung beantragt wurde
  //State wird ebenso verwendet, wenn bei einer Saldenauszahlung ein Konto einen negativen Wert hat -> Buttons müssen disabled werden
  const [saldenauszahlungDisableButtons, setSaldenauszahlungDisableButtons] = useState(false);

  const handleFabClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  //PVX Kommunikation
  useEffect(() => {
    setLoading(true);
    const payload = {
      mandant: client,
      program: edit ? "PMURA3" : "FORMUL",
      statement: "FORMULAR_LADEN",
      formularkey: formularkey,
      formular: formular.substr(1),
      ankey: ankey,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, (r) => postLaden(r));
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    if (currpos.current !== 0) {
      currpos.current = 0;
      Refresh();
    }
    // eslint-disable-next-line
  }, [felder]);
  function postLaden(response) {
    setLoading(false);
    if (response.status === 200) {
      setFelder(response.data.felder);
      setHper(response.data.hper);
      setStammfelder(response.data.stammfelder);
      setFormularBez(response.data.formularbez);
      setStatus(response.data.status);
      setAnKEyRes(response.data.ankey);
      if (response.data.ankey) {
        loadedankey.current = response.data.ankey;
      }
      let zwis = "";
      if (ans !== undefined) {
        if (ans[0] !== undefined && ankey !== "") {
          zwis = ans?.find((e) => e.key === ankey).name;
        }
      }
      setAntragsBezeichnung(zwis);
      if (response.data.formularkey !== "neu") {
        setAntragsBezeichnung(response.data.zusatzBez);
      }
      if (response.data.bemerkung) setBemerkung(response.data.bemerkung);
      if (response.data.buttons) setButtons(response.data.buttons);
      if (response.data.folgeformular) setFolgeformular(response.data.folgeformular);
      if (response.data.uebergaben) setUebergaben(response.data.uebergaben);
      ListeAufbauen(response.data.felder, response.data.stammfelder);
      change.current = false;
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  async function getFileFromUrl(url, name, defaultType = "image/png") {
    const response = await fetch(url);
    const data = await response.blob();
    return new File([data], name, {
      type: data.type || defaultType,
    });
  }
  function Speichern(zwischen) {
    setLoading(true);

    var tmpfelder = JSON.parse(JSON.stringify(felder));
    Object.keys(felder[formular]).forEach((item, index) => {
      if (felder[formular][item].art === "P") {
        tmpfelder[formular][item].felderAntworten = felder[formular][item].felderAntworten;
        if (felder[formular][item]?.felderAntworten?.file) {
          tmpfelder[formular][item].felderAntworten.file = JSON.stringify(felder[formular][item]?.felderAntworten?.file);
        }
      }
      if (felder[formular][item].typ === "14") {
        tmpfelder[formular][item].antwort = felder[formular][item].antwort;
      }
      if (felder[formular][item].art === "I") {
        //delete tmpfelder[formular][item];
        return;
      }
      if (felder[formular][item].art === "E" && felder[formular][item].inhalt) {
        tmpfelder[formular][item].inhalt = "";
      }
      if (felder[formular][item].name) {
        tmpfelder[formular][item].name = "";
      }
    });
    const payload = {
      mandant: client,
      program: edit ? "PMURA3" : "FORMUL",
      statement: "SPEICHERN",
      felder: tmpfelder,
      formular: formular,
      antragsBezeichnung: document.getElementById("antragsBezeichnungFeld")?.value ?? "",
      formularkey: formularkey,
      workflow: workflow,
      files: files,
      zwischen: zwischen,
      aenderung: change.current ? "J" : "",
      ankey: ankey ? ankey : loadedankey.current && loadedankey.current !== "" ? loadedankey.current : "",
      ans: personName,
    };
    // const data = new FormData();
    // for (let index = 0; index < files.length; index++) {
    //   data.append('file', files[index]);
    // }
    uploadFormData.current.append("payload", JSON.stringify(payload));
    const headers = {
      Authorization: "Bearer " + accessToken,
      Mandant: client,
      program: edit ? "PMURA3" : "FORMUL",
      Statement: "SPEICHERN",
    };
    apiRequest("POST", "upload", uploadFormData.current, headers, postSpeichern, errorCb);
  }
  function postSpeichern(response) {
    setLoading(false);
    if (response.status === 200 && (response.data.message === "OK" || response.data.message === "ok")) {
      if (response.data.zwischen === "Z") {
        showSuccessMessage(t("Formular gespeichert"));
      } else {
        showSuccessMessage(t("Formular abgeschickt"));
      }
      Reload();
      if (!noNavigate) {
        navigate(-1);
      }
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  function Refresh() {
    setLoading(true);
    var tmpfelder = JSON.parse(JSON.stringify(felder));
    Object.keys(felder[formular]).forEach((item, index) => {
      if (felder[formular][item].art === "P") {
        tmpfelder[formular][item].felderAntworten = felder[formular][item].felderAntworten;
      }
      if (felder[formular][item].typ === "14") {
        tmpfelder[formular][item].antwort = felder[formular][item].antwort;
      }

      if (felder[formular][item].art === "I") {
        delete tmpfelder[formular][item];
        return;
      }
      if (felder[formular][item].art === "E" && felder[formular][item].inhalt) {
        tmpfelder[formular][item].inhalt = "";
      }
      if (felder[formular][item].name) {
        tmpfelder[formular][item].name = "";
      }
    });
    const payload = {
      mandant: client,
      program: edit ? "PMURA3" : "FORMUL",
      statement: "SPEICHERN",
      felder: tmpfelder,
      formular: formular,
      formularkey: formularkey,
      files: files,
      zwischen: "Z",
      laden: "J",
      aenderung: change.current ? "J" : "",
      ankey: ankey ? ankey : loadedankey.current && loadedankey.current !== "" ? loadedankey.current : "",
    };
    // const data = new FormData();
    // for (let index = 0; index < files.length; index++) {
    //   data.append('file', files[index]);
    // }
    // data.append('payload', JSON.stringify(payload));
    uploadFormData.current.append("payload", JSON.stringify(payload));
    const headers = {
      Authorization: "Bearer " + accessToken,
      Mandant: client,
      program: edit ? "PMURA3" : "FORMUL",
      Statement: "SPEICHERN",
    };
    apiRequest("POST", "upload", uploadFormData.current, headers, postRefresh, errorCb);
  }
  function errorCb(response) {
    setLoading(false);
    showErrorMessage(response.data.message);
  }
  function postRefresh(response) {
    setLoading(false);
    if (response.status === 200) {
      setFormular(response.data.formular);
      setFormularkey(response.data.formularkey);
      setFelder(response.data.felder);
      setHper(response.data.hper);
      setStammfelder(response.data.stammfelder);
      setFormularBez(response.data.formularbez);
      setStatus(response.data.status);
      if (response.data.bemerkung) setBemerkung(response.data.bemerkung);
      if (response.data.buttons) setButtons(response.data.buttons);
      if (response.data.uebergaben) setUebergaben(response.data.uebergaben);
      ListeAufbauen(response.data.felder, response.data.stammfelder);
      change.current = false;
      if (druck.current === 1) {
        DateiLaden("komplett" + response.data.formularkey);
      }
      if (druck.current === 2) {
        FormularPDF(response.data.formularkey);
      }
      druck.current = 0;
      if (!location.pathname.includes("genehmigen")) Reload();
    } else {
      change.current = false;
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
      druck.current = 0;
    }
  }
  function FormularLoeschen() {
    const payload = {
      mandant: client,
      program: edit ? "PMURA3" : "FORMUL",
      statement: "LOESCHEN",
      formularkey: formularkey,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, (r) => postLoeschen(r));
  }
  function postLoeschen(response) {
    if (response.status === 200) {
      showSuccessMessage(t("Formular gelöscht"));
      Reload();
      if (!noNavigate) {
        navigate(-1);
      }
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  function DateiLaden(key, art) {
    if ((key === "komplettneu" || change.current) && status !== "G" && status !== "X") {
      druck.current = 1;
      setMessageBoxOpen(true);
      return;
    }
    setLoading(true);
    const payload = {
      mandant: client,
      program: edit ? "PMURA3" : "FORMUL",
      statement: "DATEI_LADEN",
      key: key,
      art: art,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
      Accept: "application/pdf",
    };
    axios
      .post(API_BASE_URL + "daten", payload, {
        headers: headers,
        responseType: "blob",
      })
      .then((response) => {
        var fileName = "Datei" + ".pdf";
        var contentFile = response.data;
        openFile(fileName, contentFile);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
        showErrorMessage("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut.");
      });
  }
  //Standardfunktionen
  function PersonenAuswahl() {
    if (Plausibilitaetspruefung() === 1) {
      showErrorMessage(t("Bitte füllen Sie alle Pflichtfelder aus"));
      return;
    }
    if (ans) {
      setOpenPers(true);
      return;
    }
    setAntragsBezeichnungModal(true);
  }
  function Storno() {
    setLoading(true);
    const payload = {
      mandant: client,
      program: edit ? "PMURA3" : "FORMUL",
      statement: "STORNO",
      formularkey: formularkey,
      formular: formular.substr(1),
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, (r) => postStorno(r));
  }
  function postStorno(response) {
    if (response.status === 200) {
      showSuccessMessage(t("Formular storniert"));
      Reload();
      if (!noNavigate) {
        navigate(-1);
      }
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  }
  function Plausibilitaetspruefung() {
    const tmpError = [];
    const form = felder?.[formular];
    if (!form) return 1;

    const rootId = "F" + formular.substr(1, 3);
    const rootField = form[rootId];
    const feldListe = rootField?.inhalt?.split(";").filter(Boolean) ?? [];

    feldListe.forEach((itemId) => {
      const field = form[itemId];
      if (!field) return;

      const prefix = itemId.substr(0, 1);

      // S = Skip / Steuerfeld ohne Pflichtprüfung
      if (prefix === "S") return;

      // G = Gruppe von Feldern
      if (prefix === "G") {
        validateGroup(form, itemId, tmpError);
        return;
      }
      // P = spezielle Felder wie BANKVERBINDUNG
      if (prefix === "P") {
        validateSpecialField(itemId, field, tmpError);
      }

      // 1. Bedingte Pflicht (logik === "03")
      validateConditionalField(form, itemId, field, tmpError);

      // 2. Normale Pflichtprüfung nach Typ
      validateRequiredField(itemId, field, tmpError);
    });

    setFelderError(tmpError);
    return tmpError.length > 0 ? 1 : 0;
  }
  function getAnswerKeys(field) {
    if (!field?.antwort) return [];
    if (typeof field.antwort === "object") {
      return Object.keys(field.antwort);
    }
    // Falls antwort ein einfacher Wert ist, behandeln wir es wie "1"
    return ["1"];
  }

  function isFieldEmpty(field, key = "1") {
    if (!field) return true;

    switch (field.typ) {
      case "01":
      case "02":
      case "03":
      case "04":
      case "06":
      case "07": {
        const value = field.antwort?.[key] ?? field.antwort;
        return value === undefined || value === "";
      }

      case "05": {
        const value = field.antwort?.[key] ?? field.antwort;
        return value === undefined || value === "" || value === "0";
      }

      case "08": {
        // Checkbox-Gruppe: mindestens eine "1" muss gesetzt sein
        if (!field.antwort) return true;

        const values = Object.values(field.antwort);
        return !values.some((v) => {
          if (v && typeof v === "object") {
            return Object.values(v).some((inner) => inner === "1");
          }
          return v === "1";
        });
      }

      case "09":
        return field.antwort === undefined || field.antwort === "";

      default:
        return false;
    }
  }
  function parseCondition(logikwert) {
    if (!logikwert) return null;

    if (logikwert.includes("=")) {
      const [left, right] = logikwert.split("=");
      return {
        operator: "=",
        fieldId: left.replaceAll("|", "").replaceAll(" ", ""),
        rawExpected: right.replace(/\s/g, ""),
      };
    }

    if (logikwert.includes("<>")) {
      const [left, right] = logikwert.split("<>");
      return {
        operator: "<>",
        fieldId: left.replaceAll("|", "").replaceAll(" ", ""),
        rawExpected: right?.replace(/\s/g, ""),
      };
    }

    // spätere Erweiterung für < oder >
    return null;
  }

  function normalizeExpected(raw) {
    if (raw === "undefined" || raw === '""') {
      return undefined;
    }
    return raw;
  }

  function conditionMatches(form, condition, contextKey) {
    const refField = form?.[condition.fieldId];
    if (!refField) return false;

    const expected = normalizeExpected(condition.rawExpected);

    // Checkbox-Gruppe: Vergleich über Key/Index
    if (refField.typ === "08" && expected !== undefined) {
      const index = String(parseInt(expected, 10) - 1);
      const value = refField.antwort?.[index + (contextKey ?? "")];
      return value === "1";
    }

    // Wert ermitteln: entweder gesamtes antwort-Objekt oder Eintrag für contextKey
    let actual = refField.antwort;
    if (contextKey != null) {
      actual = actual?.[contextKey];
    }

    if (condition.operator === "=") {
      if (expected === undefined || expected === "") {
        return actual === undefined || actual === "";
      }

      return actual === expected;
    }

    if (condition.operator === "<>") {
      if (expected === undefined || expected === "") {
        return actual !== undefined && actual !== "";
      }
      return actual !== expected;
    }

    return false;
  }
  function validateConditionalField(form, itemId, field, errors) {
    if (field.logik !== "03") return;

    const condition = parseCondition(field.logikwert);
    if (!condition) return;

    const matches = conditionMatches(form, condition, null);
    const empty = isFieldEmpty(field);

    if (matches && empty) {
      errors.push(itemId);
    }
  }
  function validateRequiredField(itemId, field, errors) {
    if (field.pflicht !== "1") return;

    // Sonderfall Checkboxgruppen (08) wird in isFieldEmpty behandelt
    const keys = getAnswerKeys(field);
    if (keys.length === 0 && isFieldEmpty(field)) {
      errors.push(itemId);
      return;
    }

    // Wenn eines der Keys eine gültige Antwort enthält, ist das Pflichtkriterium erfüllt
    const hasAnswer = keys.some((key) => !isFieldEmpty(field, key));
    if (!hasAnswer) {
      errors.push(itemId);
    }
  }
  function validateSpecialField(itemId, field, errors) {
    if (field.extra === "BANKVERBINDUNG") {
      const iban = field.felderAntworten?.iban;
      if (!iban) {
        errors.push(itemId);
      }
    }
    if (field.extra === "SALDENAUSZAHLUNG") {
      if (field.felderAntworten.error) {
        errors.push("SALDENAUSZAHLUNG");
      }
    }
  }
  function validateGroup(form, groupId, errors) {
    const groupField = form[groupId];
    if (!groupField?.inhalt) return;

    let istPflicht = 0;
    const truePflicht = {};

    const tmparray = groupField.inhalt.split(";").filter(Boolean);

    tmparray.forEach((item2, index2) => {
      const field = form[item2];
      if (!field || item2.substr(0, 1) !== "E") return;

      if (truePflicht[item2] === undefined) {
        truePflicht[item2] = 0;
      }

      // bedingte Pflicht innerhalb der Gruppe
      if (field.logik === "03") {
        const condition = parseCondition(field.logikwert);
        if (condition) {
          const keys = getAnswerKeys(form[condition.fieldId]);
          if (keys.length === 0) {
            // Bedingungsfeld komplett leer → keine Pflicht innerhalb der Gruppe
            return;
          }

          keys.forEach((key) => {
            const empty = isFieldEmpty(field, key);
            const matches = conditionMatches(form, condition, key);
            console.log(form, condition, key);
            console.log(matches, empty);
            if (matches && empty) {
              // Fehlercode orientiert sich an deiner ursprünglichen Logik
              errors.push(item2 + key);
            }
          });
        }
        return;
      }
      // Pflicht-Erfüllung pro Element innerhalb der Gruppe
      const keys = getAnswerKeys(field);

      keys.forEach((key) => {
        const empty = isFieldEmpty(field, key);
        if (empty) return;

        istPflicht = Math.max(Number(key), istPflicht);

        if (field.pflicht === "1" && Number(key) - truePflicht[item2] <= 1) {
          truePflicht[item2] = Number(key);
        }
      });
    });

    // Abschlussprüfung über alle Pflichtfelder in der Gruppe

    Object.keys(truePflicht).forEach((key) => {
      const field = form[key];
      if (!field || field.pflicht !== "1") return;

      if (field.typ === "08") {
        // Checkboxgruppen
        if (istPflicht >= truePflicht[key]) {
          errors.push(key + istPflicht.toString());
        }
      } else {
        if (istPflicht > truePflicht[key]) {
          errors.push(key + istPflicht.toString());
        }
      }
    });
  }
  // function Plausibilitaetspruefung() {
  //   var tmpError = [];
  //   var inhalt = felder[formular]["F" + formular.substr(1, 3)].inhalt;
  //   var tmpliste = inhalt.split(";");
  //   tmpliste.forEach((item, index) => {
  //     if (item.substr(0, 1) === "S") return;
  //     if (item.substr(0, 1) === "G") {
  //       var istPflicht = 0;
  //       var truePflicht = {};
  //       var tmparray = felder[formular][item].inhalt.split(";");
  //       tmparray.forEach((item2, index2) => {
  //         if (item2.substr(0, 1) !== "E") return;

  //         if (truePflicht[item2] == undefined) truePflicht[item2] = 0;
  //         if (felder[formular][item2].logik === "03") {
  //           // Hier wird Pflicht aufgrund von Bedingung geprüft.
  //           // if (!felder[formular][item2].antwort || felder[formular][item2].antwort.length === 0) return;
  //           if (felder[formular][item2].logikwert.includes("=")) {
  //             let bedingung = felder[formular][item2].logikwert.split("=");
  //             bedingung[0] = bedingung[0].replaceAll("|", "").replaceAll(" ", "");
  //             bedingung[1] = bedingung[1].replace(/\s/g, "");
  //             var keys = Object.keys(felder[formular][bedingung[0]]?.antwort ?? []);
  //             if (keys.length === 0) {
  //               // tmpError.push(item2 + "1");
  //             }
  //           }
  //           if (keys.length === 0) {
  //             return;
  //           }
  //           keys.forEach((key) => {
  //             if (felder[formular][item2]?.antwort?.[key] !== "" && felder[formular][item2]?.antwort?.[key] !== undefined) return;
  //             if (felder[formular][item2].logikwert.includes("=")) {
  //               let bedingung = felder[formular][item2].logikwert.split("=");
  //               bedingung[0] = bedingung[0].replaceAll("|", "").replaceAll(" ", "");
  //               bedingung[1] = bedingung[1].replace(/\s/g, "");
  //               if (bedingung[1] === "undefined") {
  //                 bedingung[1] = undefined;
  //               }
  //               if (felder[formular][bedingung[0]].typ === "08") {
  //                 //Checkboxgruppe

  //                 if (felder[formular][bedingung[0]]?.antwort) {
  //                   if ((parseInt(bedingung[1]) - 1).toString() + "_" + (index2 - 1) === key) {
  //                     if (felder[formular][bedingung[0]]?.antwort[key] === "1") {
  //                       tmpError.push(item2 + parseInt(index2 - 1));
  //                     }
  //                   }
  //                   // console.log(felder[formular][bedingung[0]]?.antwort[key])
  //                 }
  //               }
  //               if (felder[formular][bedingung[0]].typ === "05") {
  //                 if (
  //                   (felder[formular][bedingung[0]]?.antwort?.[key] === "" || felder[formular][bedingung[0]]?.antwort?.[key] === undefined) &&
  //                   bedingung[1] === "0"
  //                 ) {
  //                   console.log("error:")
  //                   console.log(item2+key)
  //                   tmpError.push(item2 + key);
  //                 }
  //               }
  //             } else if (felder[formular][item2].logikwert.includes("<>")) {
  //               let bedingung = felder[formular][item2].logikwert.split("<>");
  //               bedingung[0] = bedingung[0].replaceAll("|", "").replaceAll(" ", "");
  //               if (bedingung[1] === "undefined") {
  //                 bedingung[1] = undefined;
  //               }

  //               if (felder[formular][bedingung[0]]?.antwort !== bedingung[1]) {
  //                 console.log("error:push")
  //                 tmpError.push(item2);
  //               }
  //             } else if (felder[formular][item2].logikwert.includes("<")) {
  //             } else if (felder[formular][item2].logikwert.includes(">")) {
  //             }
  //           });
  //         }
  //         if (!felder[formular][item2].antwort || felder[formular][item2].antwort.length === 0) {
  //           var keys = ["1"];
  //         } else {
  //           var keys = Object.keys(felder[formular][item2].antwort);
  //         }
  //         keys.forEach((key) => {

  //           if ((felder[formular][item2].antwort?.[key] == "" && felder[formular][item2].typ !== "09") || felder[formular][item2].antwort?.[key] === undefined)
  //             return;
  //           if (felder[formular][item2].typ === "08") {
  //             if (felder[formular][item2]?.antwort?.[key] === "0") {
  //               return;
  //             }
  //           }

  //           istPflicht = Math.max(Number(key), istPflicht);
  //           if (felder[formular][item2].pflicht === "1" && Number(key) - truePflicht[item2] <= 1) truePflicht[item2] = Number(key);
  //         });
  //       });

  //       var keys = Object.keys(truePflicht);
  //       keys.forEach((key) => {
  //         if (felder[formular][key].pflicht !== "1") return;

  //         if (felder[formular][key].typ === "08") {
  //           if (istPflicht >= truePflicht[key]) {
  //             tmpError.push(key + istPflicht.toString());
  //           }
  //         } else {
  //           if (istPflicht > truePflicht[key]) {

  //             tmpError.push(key + istPflicht.toString());
  //           }
  //         }
  //       });
  //     }
  //     if (felder[formular][item].logik === "03") {
  //       // Hier wird Pflicht aufgrund von Bedingung geprüft.
  //       if (checkError(felder, formular, item)) {
  //         if (felder[formular][item].logikwert.includes("=")) {
  //           let bedingung = felder[formular][item].logikwert.split("=");
  //           bedingung[0] = bedingung[0].replaceAll("|", "").replaceAll(" ", "");
  //           bedingung[1] = bedingung[1].replace(/\s/g, "");
  //           if (bedingung[1] === "undefined") {
  //             bedingung[1] = undefined;
  //           }

  //           if (felder[formular][bedingung[0]].typ === "08") {
  //             //Checkboxgruppe
  //             if (felder[formular][bedingung[0]]?.antwort) {
  //               if (felder[formular][bedingung[0]]?.antwort[parseInt(bedingung[1]) - 1] === "1") {
  //                 tmpError.push(item);
  //               }
  //             }
  //           }
  //           if (bedingung[1] === "" || bedingung[1] === undefined || bedingung[1] === '""') {
  //             if (felder[formular][bedingung[0]]?.antwort === "" || felder[formular][bedingung[0]]?.antwort === undefined) {
  //               tmpError.push(item);
  //             }
  //           } else if (felder[formular][bedingung[0]]?.antwort === bedingung[1]) {
  //             tmpError.push(item);
  //           }
  //         } else if (felder[formular][item].logikwert.includes("<>")) {
  //           let bedingung = felder[formular][item].logikwert.split("<>");
  //           bedingung[0] = bedingung[0].replaceAll("|", "").replaceAll(" ", "");
  //           if (bedingung[1] === "undefined") {
  //             bedingung[1] = undefined;
  //           }
  //           if (bedingung[1] === "" || bedingung[1] === undefined || bedingung[1] === '""') {
  //             console.log(bedingung[1]);
  //             console.log(felder[formular][bedingung[0]]?.antwort);
  //             if (felder[formular][bedingung[0]]?.antwort !== "" && felder[formular][bedingung[0]]?.antwort !== undefined) {
  //               tmpError.push(item);
  //             }
  //           } else if (felder[formular][bedingung[0]]?.antwort !== bedingung[1]) {
  //             tmpError.push(item);
  //           }
  //           // if (felder[formular][bedingung[0]]?.antwort !== bedingung[1]) {
  //           //   tmpError.push(item);
  //           // }
  //         } else if (felder[formular][item].logikwert.includes("<")) {
  //         } else if (felder[formular][item].logikwert.includes(">")) {
  //         }
  //       }
  //     }
  //     if (item.substr(0, 1) === "P") {
  //       if (felder[formular][item].extra === "BANKVERBINDUNG") {
  //         if (felder[formular][item].felderAntworten?.iban === "" || felder[formular][item].felderAntworten?.iban === undefined) {
  //           tmpError.push(item);
  //         }
  //       }
  //     }
  //     if (felder[formular][item].pflicht !== "1") return;
  //     var typ = felder[formular][item].typ;
  //     if (typ === "01") {
  //       if (!felder[formular][item].antwort || felder[formular][item].antwort === "") tmpError.push(item);
  //     }
  //     if (typ === "02") {
  //       if (!felder[formular][item].antwort || felder[formular][item].antwort === "") tmpError.push(item);
  //     }
  //     if (typ === "03") {
  //       if (!felder[formular][item].antwort || felder[formular][item].antwort === "") tmpError.push(item);
  //     }
  //     if (typ === "04") {
  //       if (!felder[formular][item].antwort || felder[formular][item].antwort === "") tmpError.push(item);
  //     }
  //     if (typ === "05") {
  //       if (!felder[formular][item].antwort || felder[formular][item].antwort === "0") tmpError.push(item);
  //     }
  //     if (typ === "06") {
  //       if (!felder[formular][item].antwort || felder[formular][item].antwort === "") tmpError.push(item);
  //     }
  //     if (typ === "07") {
  //       if (!felder[formular][item].antwort || felder[formular][item].antwort === "") tmpError.push(item);
  //     }
  //     if (typ === "08") {
  //       if (!felder[formular][item].antwort) {
  //         tmpError.push(item);
  //       } else {
  //         var check = 0;
  //         const items = Object.values(felder[formular][item].antwort);
  //         items.forEach((item) =>
  //           Object.entries(item).forEach(([key, value]) => {
  //             if (value === "1") check = 1;
  //           }),
  //         );
  //         if (check === 0) tmpError.push(item);
  //       }
  //     }
  //     if (typ === "09") {
  //       if (felder[formular][item].antwort === undefined) {
  //         tmpError.push(item);
  //       }
  //       if (felder[formular][item].antwort === "") {
  //         tmpError.push(item);
  //       }
  //     }
  //   });
  //   setFelderError(tmpError);
  //   if (tmpError.length > 0) {
  //     return 1;
  //   } else {
  //     return 0;
  //   }
  // }
  const checkError = (felder, formular, item) => {
    var typ = felder[formular][item].typ;
    if (typ === "01") {
      if (!felder[formular][item].antwort || felder[formular][item].antwort === "") return true;
    }
    if (typ === "02") {
      if (!felder[formular][item].antwort || felder[formular][item].antwort === "") return true;
    }
    if (typ === "03") {
      if (!felder[formular][item].antwort || felder[formular][item].antwort === "") return true;
    }
    if (typ === "04") {
      if (!felder[formular][item].antwort || felder[formular][item].antwort === "") return true;
    }
    if (typ === "05") {
      if (!felder[formular][item].antwort || felder[formular][item].antwort === "0") return true;
    }
    if (typ === "06") {
      if (!felder[formular][item].antwort || felder[formular][item].antwort === "") return true;
    }
    if (typ === "07") {
      if (!felder[formular][item].antwort || felder[formular][item].antwort === "") return true;
    }
    if (typ === "08") {
      if (!felder[formular][item].antwort) {
        return true;
      } else {
        var check = 0;
        const items = Object.values(felder[formular][item].antwort);
        items.forEach((item) =>
          Object.entries(item).forEach(([key, value]) => {
            if (value === "1") check = 1;
          }),
        );
        if (check === 0) return true;
      }
    }
    if (typ === "09") {
      if (felder[formular][item].antwort === undefined) {
        return true;
      }
      if (felder[formular][item].antwort === "") {
        return true;
      }
    }
    return false;
  };
  function ListeAufbauen(tmpfelder, tmpstammfelder) {
    if (!tmpfelder[formular]) return;
    var inhalt = tmpfelder[formular]["F" + formular.substr(1, 3)].inhalt.split(";");
    var i;
    var tmpliste = [];
    for (i = 0; i < inhalt.length; i++) {
      if (inhalt[i] === "") continue;
      if (!tmpfelder[formular][inhalt[i]] && !tmpstammfelder[inhalt[i]]) continue;
      tmpliste.push(inhalt[i]);
    }
    setListeFormular(tmpliste);
  }
  function ChangeFelder(bonus, value, newfelder) {
    if (bonus === "upload" && formular === "G501") {
      currpos.current = 1;
    }
    setFelder({ ...newfelder });
    change.current = true;
  }
  function ChangeFiles(newFile) {
    var tmpliste = files;

    tmpliste.push(newFile);
    setFiles(tmpliste);
    uploadFormData.current.append("file", newFile);
    change.current = true;
  }
  function FormularPruefen() {
    if (Plausibilitaetspruefung() === 1) {
      showErrorMessage(t("Bitte füllen Sie alle Pflichtfelder aus1"));
    } else {
      showSuccessMessage(t("Formular erfolgreich geprüft"));
    }
  }
  function FormularSpeichern() {
    if (Plausibilitaetspruefung() === 1) {
      showErrorMessage(t("Bitte füllen Sie alle Pflichtfelder aus"));
      return;
    }
    setAntragsBezeichnungModal(true);
    // Speichern();
  }
  function FormularPDF(fkey) {
    if ((fkey === "neu" || change.current) && status !== "G" && status !== "X") {
      druck.current = 2;
      setMessageBoxOpen(true);
      return;
    }
    setLoading(true);
    const payload = {
      mandant: client,
      program: edit ? "PMURA3" : "FORMUL",
      statement: "PDF_LADEN",
      key: fkey,
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
      Accept: "application/pdf",
    };
    axios
      .post(API_BASE_URL + "daten", payload, {
        headers: headers,
        responseType: "blob",
      })
      .then((response) => {
        var fileName = "Formular.pdf";
        var contentFile = response.data;
        openFile(fileName, contentFile);
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
        showErrorMessage("Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut.");
      });
  }
  const messageBoxResult = (result) => {
    setMessageBoxOpen(false);
    if (result === "YES") {
      Refresh();
    }
  };
  const delmsgResult = (result) => {
    setDelmsg(false);
    if (result === "YES") {
      FormularLoeschen();
    }
  };
  const stornomsgResult = (result) => {
    setStornomsg(false);
    if (result === "YES") {
      Storno();
    }
  };
  function SelectChange(e, newValue) {
    var tmpliste = newValue;
    //tmpliste.push(e.target.value)
    setPersonName(tmpliste);
  }

  const buttons_desktop = (
    <>
      {(!status || status === "O") && (
        <Grid item xs={12} md={6}>
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            onClick={() => {
              setAntragsBezeichnungZwischenSpeichernModal(true);
            }}
          >
            <SaveIcon /> {t("Formular zwischenspeichern")}
          </Button>
        </Grid>
      )}
      {(!status || (status === "B" && !folgeformular) || status === "O") && buttons.includes("M") && (
        <Grid item xs={12} md={6}>
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            onClick={() => {
              PersonenAuswahl();
            }}
          >
            <SendIcon /> {t("Formular absenden")}
          </Button>
        </Grid>
      )}

      {(!status || (status === "B" && !folgeformular) || status === "O") && buttons.includes("A") && (
        <Grid item xs={12} md={6}>
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            onClick={() => {
              FormularSpeichern();
            }}
          >
            <SendIcon /> {t("Formular absenden")}
          </Button>
        </Grid>
      )}

      {status === "G" && buttons.includes("S") && !folgeformular && (
        <Grid item xs={12} md={6}>
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            onClick={() => {
              setStornomsg(true);
            }}
          >
            {t("Formular stornieren")}
          </Button>
        </Grid>
      )}
    </>
  );
  const actionButtons = (
    <Grid container justifyContent="center" spacing={2}>
      {(!status || status === "B" || status === "O") && (
        <Grid item xs={12}>
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            disabled={saldenauszahlungDisableButtons}
            onClick={() => {
              FormularPruefen();
            }}
          >
            {t("Formular prüfen")}
          </Button>
        </Grid>
      )}
      {(!status || (status === "B" && !folgeformular) || status === "O") && buttons.includes("A") && (
        <Grid item xs={12}>
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            disabled={saldenauszahlungDisableButtons}
            onClick={() => {
              FormularSpeichern();
            }}
          >
            {t("Formular absenden")}
          </Button>
        </Grid>
      )}
      {(!status || (status === "B" && !folgeformular) || status === "O") && buttons.includes("M") && (
        <Grid item xs={12}>
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            disabled={saldenauszahlungDisableButtons}
            onClick={() => {
              PersonenAuswahl();
            }}
          >
            {t("Formular absenden")}
          </Button>
        </Grid>
      )}
      {(!status || status === "O") && (
        <Grid item xs={12}>
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            disabled={saldenauszahlungDisableButtons}
            onClick={() => {
              setAntragsBezeichnungZwischenSpeichernModal(true);
            }}
          >
            {t("Formular zwischenspeichern")}
          </Button>
        </Grid>
      )}
      {status === "G" && buttons.includes("S") && !folgeformular && (
        <Grid item xs={12}>
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            disabled={saldenauszahlungDisableButtons}
            onClick={() => {
              setStornomsg(true);
            }}
          >
            {t("Formular stornieren")}
          </Button>
        </Grid>
      )}
      {(status === "" || status === "B" || status === "O") && (
        <Grid item xs={12}>
          <Button
            fullWidth
            variant="outlined"
            color="primary"
            disabled={saldenauszahlungDisableButtons}
            onClick={() => {
              setDelmsg(true);
            }}
          >
            {t("Formular löschen")}
          </Button>
        </Grid>
      )}
      <Grid item xs={12}>
        <Button
          fullWidth
          variant="outlined"
          color="primary"
          onClick={() => {
            FormularPDF(formularkey);
          }}
        >
          {t("Formular in PDF")}
        </Button>
      </Grid>
      <Grid item xs={12}>
        <Button
          fullWidth
          variant="outlined"
          color="primary"
          onClick={() => {
            DateiLaden("komplett" + formularkey);
          }}
        >
          {t("Alle Belege in PDF")}
        </Button>
      </Grid>
    </Grid>
  );

  //Renderfunktionen
  // #region Rückgabe
  return (
    <Fragment>
      <Grid container justifyContent="center" spacing={2}>
        <Grid item xs={12}></Grid>
      </Grid>
      <Grid container justifyContent="flex-start" spacing={2}>
        <Grid item xs={0} sm={0} md={2} display={{ xs: "none", md: "block" }}>
          <Box p={3}>
            <Card>
              <Box p={2}>{actionButtons}</Box>
            </Card>
          </Box>
        </Grid>

        <Grid item xs={12} md={10}>
          <div id="formular">
            <Formular
              setHtmlCode={setHtmlCode}
              key={felder[formular]}
              formularkey={formularkey}
              bez={formularBez}
              formular={formular}
              liste={listeFormular}
              felder={felder}
              stammfelder={stammfelder}
              hper={hper}
              ChangeFelder={ChangeFelder}
              uebergaben={uebergaben}
              felderError={felderError}
              lock={status === "G" || status === "X" || status === "S"}
              ChangeFiles={ChangeFiles}
              files={files}
              DateiLaden={DateiLaden}
              bemerkung={bemerkung}
              ZSpeichern={Refresh}
              client={client}
              accessToken={accessToken}
              program={"FORMUL"}
              setSaldenauszahlungDisableButtons={setSaldenauszahlungDisableButtons}
              ankeyRes={ankeyRes}
              bearbeiten={bearbeiten}
            />
          </div>
        </Grid>
      </Grid>
      <Grid container justifyContent="flex-end" spacing={1} paddingBottom={5}>
        <Grid item xs={12} md={10}>
          <Box p={3}>
            <Card>
              <Box p={2}>
                <Grid container justifyContent="center" spacing={2}>
                  {(!status || (status === "B" && !folgeformular) || status === "O") && buttons.includes("A") && (
                    <Grid item xs={12} md={6}>
                      <Button
                        fullWidth
                        variant="outlined"
                        color="primary"
                        disabled={saldenauszahlungDisableButtons}
                        onClick={() => {
                          FormularSpeichern();
                        }}
                      >
                        {t("Formular absenden")}
                      </Button>
                    </Grid>
                  )}
                  {(!status || (status === "B" && !folgeformular) || status === "O") && buttons.includes("M") && (
                    <Grid item xs={12} md={6}>
                      <Button
                        fullWidth
                        variant="outlined"
                        color="primary"
                        disabled={saldenauszahlungDisableButtons}
                        onClick={() => {
                          PersonenAuswahl();
                        }}
                      >
                        {t("Formular absenden")}
                      </Button>
                    </Grid>
                  )}
                  {(!status || status === "O") && (
                    <Grid item xs={12} md={6}>
                      <Button
                        fullWidth
                        variant="outlined"
                        color="primary"
                        disabled={saldenauszahlungDisableButtons}
                        onClick={() => {
                          setAntragsBezeichnungZwischenSpeichernModal(true);
                        }}
                      >
                        {t("Formular zwischenspeichern")}
                      </Button>
                    </Grid>
                  )}
                  {(status === "" || status === "B" || status === "O") && (
                    <Grid item xs={12}>
                      <Button
                        fullWidth
                        variant="outlined"
                        color="primary"
                        disabled={saldenauszahlungDisableButtons}
                        onClick={() => {
                          setDelmsg(true);
                        }}
                      >
                        {t("Formular löschen")}
                      </Button>
                    </Grid>
                  )}
                  <Grid item xs={12} sx={{ display: { xs: "block", md: "none" } }}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        FormularPDF(formularkey);
                      }}
                    >
                      {t("Formular in PDF")}
                    </Button>
                  </Grid>
                  <Grid item xs={12} sx={{ display: { xs: "block", md: "none" } }}>
                    <Button
                      fullWidth
                      variant="outlined"
                      color="primary"
                      onClick={() => {
                        DateiLaden("komplett" + formularkey);
                      }}
                    >
                      {t("Alle Belege in PDF")}
                    </Button>
                  </Grid>
                  {status === "G" && buttons.includes("S") && !folgeformular && (
                    <Grid item xs={12} md={6}>
                      <Button
                        fullWidth
                        variant="outlined"
                        color="primary"
                        onClick={() => {
                          setStornomsg(true);
                        }}
                      >
                        {t("Formular stornieren")}
                      </Button>
                    </Grid>
                  )}
                </Grid>
              </Box>
            </Card>
          </Box>
        </Grid>

        <div>
          <Fab
            color="primary"
            aria-label="add"
            size="small"
            sx={{
              position: "fixed",
              bottom: 20,
              right: 20,
              justifyContent: "center",
              display: { xs: "block", md: "none" },
            }}
            onClick={handleFabClick}
          >
            <MoreVertIcon sx={{ marginTop: "5px" }} />
          </Fab>
          <Popover
            open={Boolean(anchorEl)}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "right",
            }}
          >
            <Card>{actionButtons}</Card>
          </Popover>
        </div>
      </Grid>
      {ans && ans.length > 0 && (
        <ResponsiveDialog
          title={t("Pflichtdokument an weitere Personen senden")}
          open={openPers}
          setOpen={() => {
            setPersonName([]);
            setOpenPers(false);
          }}
          actionButton={
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    setPersonName([]);
                    setOpenPers(false);
                  }}
                >
                  {t("Abbrechen")}
                </Button>
              </Grid>
              <Grid item>
                <Button variant="outlined" color="primary" onClick={() => setAntragsBezeichnungModal(true)}>
                  {t("Auswahl")}
                </Button>
              </Grid>
            </Grid>
          }
        >
          <Box p={2} fullWidth>
            <FormControl fullWidth>
              {/* <InputLabel id="demo-multiple-chip-label">
                {t("Weitere Personen")}
              </InputLabel>               */}
              <Autocomplete
                multiple
                id="tags-standard"
                options={ans}
                renderOption={(props, option) => {
                  return <li {...props}>{option.vkey + " - " + option.name}</li>;
                }}
                getOptionLabel={(option) => option.name}
                onChange={(e, newValue) => SelectChange(e, newValue)}
                renderInput={(params) => <TextField {...params} variant="standard" label="Personen auswählen" placeholder="Suchen" />}
              />
              {/* <Select
                labelId="demo-multiple-chip-label"
                id="demo-multiple-chip"
                multiple
                fullWidth
                value={personName}
                onChange={(e) => SelectChange(e)}
                input={
                  <OutlinedInput
                    id="select-multiple-chip"
                    label={t("Weitere Personen")}
                  />
                }
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((value, ind) => (
                      <>
                        {console.log(value)}
                        <Chip key={value.key} label={value.name} />
                      </>
                    ))}
                  </Box>
                )}
                MenuProps={MenuProps}
              >
                {ans.map((item, index) => {
                  if (ankey && ankey === item.key) return;
                  return (
                    <MenuItem key={item.key} value={item}>
                      {item.vkey + " - " + item.name}
                    </MenuItem>
                  );
                })}
              </Select> */}
            </FormControl>
          </Box>
        </ResponsiveDialog>
      )}
      <MessageBox
        title={t("Hinweis Druck")}
        text={t("Für den PDF-Druck muss zuerst zwischengespeichert werden - möchten Sie das?")}
        buttons="YESNOCANCEL"
        onClose={() => {
          setMessageBoxOpen(false);
          druck.current = 0;
        }}
        open={messageBoxOpen}
        handleResponse={(r) => messageBoxResult(r)}
      />
      <MessageBox
        title={t("Formular löschen")}
        text={t("Möchten Sie das Formular wirklich löschen?")}
        buttons="YESNOCANCEL"
        onClose={() => {
          setDelmsg(false);
        }}
        open={delmsg}
        handleResponse={(r) => delmsgResult(r)}
      />
      <ResponsiveDialog
        title={t("Antragsbezeichnung ändern")}
        actionButton={
          <>
            <Box p={2}>
              <Button color="primary" onClick={() => setAbsendenMSG(true)}>
                {t("Speichern")}
              </Button>
            </Box>
            <Box p={2}>
              <Button color="primary" onClick={() => setAntragsBezeichnungModal(false)}>
                {t("Zurück")}
              </Button>
            </Box>
          </>
        }
        setOpen={(o) => setAntragsBezeichnungModal(false)}
        open={antragsBezeichnungModal}
      >
        <Box p={2}>
          <form>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="body1">
                  {t("Sie können optional einen individuellen Namen vergeben um das Formular später leichter wieder zu finden.")}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField fullWidth label={t("Formularbezeichnung")} disabled value={formularBez}></TextField>
              </Grid>
              <Grid item xs={12} sm={8}>
                <TextField
                  fullWidth
                  defaultValue={antragsBezeichnung}
                  // onChange={(e) => setAntragsBezeichnung(e.target.value)}
                  autoComplete="false"
                  autoCorrect="false"
                  autoFocus
                  id="antragsBezeichnungFeld"
                  inputProps={{
                    maxLength: 50,
                  }}
                  // helperText={document.getElementById("antragsBezeichnungFeld")?.value.length + "/50"}
                  variant="outlined"
                  label={t("Zusatztext (optional) ")}
                  placeholder={t("Zusatztext eingeben")}
                />
              </Grid>
            </Grid>
          </form>
        </Box>
      </ResponsiveDialog>
      <ResponsiveDialog
        title={t("Antragsbezeichnung ändern")}
        actionButton={
          <>
            <Box p={2}>
              <Button color="primary" onClick={() => Speichern("Z")}>
                {t("Speichern")}
              </Button>
            </Box>
            <Box p={2}>
              <Button color="primary" onClick={() => setAntragsBezeichnungZwischenSpeichernModal(false)}>
                {t("Zurück")}
              </Button>
            </Box>
          </>
        }
        setOpen={(o) => setAntragsBezeichnungZwischenSpeichernModal(false)}
        open={antragsBezeichnungZwischenSpeichernModal}
      >
        <Box p={2}>
          <form>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="body1">
                  {t("Sie können optional einen individuellen Namen vergeben um das augefüllte Formular später leichter wieder zu finden.")}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField fullWidth label={t("Formularbezeichnung")} disabled value={formularBez}></TextField>
              </Grid>
              <Grid item xs={12} sm={8}>
                <TextField
                  fullWidth
                  defaultValue={antragsBezeichnung}
                  // onChange={(e) => setAntragsBezeichnung(e.target.value)}
                  autoComplete="false"
                  autoCorrect="false"
                  autoFocus
                  id="antragsBezeichnungFeld"
                  inputProps={{
                    maxLength: 50,
                  }}
                  // helperText={document.getElementById("antragsBezeichnungFeld")?.value.length + "/50"}
                  variant="outlined"
                  label={t("Zusatztext (optional) ")}
                  placeholder={t("Zusatztext eingeben")}
                />
              </Grid>
            </Grid>
          </form>
        </Box>
      </ResponsiveDialog>
      <MessageBox
        title={t("Formular absenden")}
        text={[
          '"' + formularBez + " " + document.getElementById("antragsBezeichnungFeld")?.value + '"' ?? "",
          t("Möchten Sie das Formular wirklich absenden?"),
        ]}
        buttons="YESNO"
        onClose={() => {
          setAbsendenMSG(false);
        }}
        open={absendenMSG}
        handleResponse={(response) => {
          if (response === "YES") {
            Speichern();
          } else {
            setAbsendenMSG(false);
          }
        }}
      />
      <MessageBox
        title={t("Formular stornieren")}
        text={t("Möchten Sie das Formular wirklich stornieren?")}
        buttons="YESNOCANCEL"
        onClose={() => {
          setStornomsg(false);
        }}
        open={stornomsg}
        handleResponse={(r) => stornomsgResult(r)}
      />
      {loading && <FullPageSpinner />}
    </Fragment>
  );
}
export default FormularEingabe;
